{
  "info": "Informacije",
  "negative": "Napaka",
  "positive": "Uspešno"
}
